export const environment = {
  production: true,
  gaTrackingID: 'UA-8559254-1'
};
